import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { RemoteDiagnosticsVddGenericStructure, SetNewValueObject } from '@vi-iot/client';
import { FormControl, Validators } from '@angular/forms';
import { InputValuePipe } from '../../../../../../shared/pipes/input-value/input-value.pipe';
import { DiagnosticsFormGroupService } from '../diagnostics-form-group.service';

@Component({
  selector: 'app-vdd-vin',
  templateUrl: './vdd-vin.component.html',
  styleUrls: ['./vdd-vin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddVinComponent implements OnInit {
  @Input() matchedValue: RemoteDiagnosticsVddGenericStructure;
  @Input() diagnosticsFormGroupService: DiagnosticsFormGroupService;
  @Input() isVddEditable: boolean;
  @Input() vddName: string;
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();
  vinFormControl: FormControl<string>;
  vinLength = 16;

  constructor(private inputValuePipe: InputValuePipe) {}

  ngOnInit(): void {
    const value = this.matchedValue.structure.map((structure) => structure.value).join('');
    this.vinFormControl = new FormControl<string>(value, [
      Validators.minLength(this.vinLength),
      Validators.maxLength(this.vinLength),
      Validators.pattern(/^[0-9]\d*$/),
    ]);
    if (!this.isVddEditable) {
      this.vinFormControl.disable();
    }
    this.diagnosticsFormGroupService.addFormControl(
      `${this.matchedValue.path}`,
      this.vinFormControl
    );
  }

  valueChange(event): void {
    const newValue = this.inputValuePipe.transform(event);
    if (newValue.length === this.vinLength) {
      const slicePairIndexes = [
        [0, 7], // PA_ItemId
        [7, 8], // PA_Year
        [8, 13], // PA_ProceCount
        [13, 14], // PA_OverfCountOne
        [14, 15], // PA_OverfTwo
        [15, 16], // PA_Check
      ];
      this.matchedValue.structure.forEach((structureElement, index) => {
        const valueToSend = this.getNewValue(
          slicePairIndexes[index][0],
          slicePairIndexes[index][1],
          newValue,
          structureElement
        );
        if (valueToSend !== null) {
          this.setNewValue.emit({
            path: valueToSend.path,
            newValue: valueToSend.value,
          });
        }
      });
    }
  }

  private getNewValue(
    startIndex: number,
    endIndex: number,
    newValue: string,
    matchedValue: RemoteDiagnosticsVddGenericStructure
  ): { path: string; value: string } {
    const slicedValue = newValue.slice(startIndex, endIndex);
    if (matchedValue.value === slicedValue) {
      return null;
    } else {
      return {
        path: matchedValue.path,
        value: slicedValue,
      };
    }
  }
}
